import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Filters,
  Image,
  ChoiceList,
  Loading,
  Card,
  Text,
  Banner,
  Spinner,
  ButtonGroup,
  Button,
  Modal,
  Badge,
  Toast,
  TextContainer,
  Link,
  Icon,
  FormLayout,
  Tooltip,
  Select,
  Layout,
  Thumbnail,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import { ArrowUpIcon, ArrowDownIcon } from "@shopify/polaris-icons";
import EllipsisText from "react-ellipsis-text";

const Portfolio = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const refBoolPage = useRef(true);
  const refId = useRef(null);
  const [popupActive, setPopupActive] = useState(false);
  const perPage = 200;
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [sortState, setSortState] = useState("-id");
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleSort = () =>
    sortState === "id" ? setSortState("-id") : setSortState("id");
  const handleEdit = (id) => {
    navigate(`/admin/portfolio/${id}`);
  };
  const handleGallery = (id) => {
    navigate(`/admin/portfolio/${id}/gallery`);
  };
  const [ts, setTs] = useState("");
  const [isWebsiteProtected, setIsWebsiteProtected] = useState(false);
  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState("");
  const handleSelectChangeChannel = (value) => {
    setSelectedChannel(value);
  };
  const handleUp = (e) => {
    const bodyObj = {
      direction: "up",
    };
    axios
      .post(`/portfolios/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const handleDown = (e) => {
    const bodyObj = {
      direction: "down",
    };
    axios
      .post(`/portfolios/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  useEffect(() => {
    fetchData();
  }, [page, sortState, availability, queryValue, ts, props, selectedChannel]);

  async function fetchData() {
    let responsePages = "";

    try {
      responsePages = await axios.get(
        `/portfolios?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${queryValue ? `&filter[global_search]=${queryValue}` : ""}`
      );
      !responsePages.data.data.data.length
        ? setIsListEmpty(true)
        : setIsListEmpty(false);
      setTotalPages(responsePages.data.data.total);
      setItems(
        responsePages.data.data.data.map((item, index) => [
          // <div className="row_click2">
          //   {item?.image ? <Thumbnail size="small" source={item?.image} /> : ""}
          // </div>,
          <div className="row_click2">{item?.title ? item?.title : ""}</div>,
          <div className="row_click2">{item?.alias ? item?.alias : ""}</div>,
          <div className="row_click2">
            {item?.country ? item?.country?.name : ""}
          </div>,
          <div className="row_click2">
            {item?.category ? item?.category?.name : ""}
          </div>,
          <div className="row_click2">
            {item.is_featured ? <Badge status="warning">Featured</Badge> : ""}
          </div>,
          <div className="row_click2">
            <Badge status={item.is_active ? "success" : "info"}>
              {item.is_active ? "Active" : "Draft"}
            </Badge>
          </div>,
          <div className="me-3">
            <ButtonGroup>
              <Button onClick={() => handleGallery(item.id)} primary>
                Gallery
              </Button>
              <Button id={String(item.id)} onClick={(e) => handleUp(e)}>
                <Icon source={ArrowUpIcon}></Icon>
              </Button>

              <Button id={String(item.id)} onClick={(e) => handleDown(e)}>
                <Icon source={ArrowDownIcon}></Icon>
              </Button>
              <Button onClick={() => handleEdit(item.id)} loading={isSaving}>
                Edit
              </Button>
            </ButtonGroup>
          </div>,
        ])
      );
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[{ label: "Title", value: "title" }]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }

  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);

  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };

  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`brands/${refId.current}`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };

  return (
    <Page
      title="Portfolio"
      primaryAction={
        <ButtonGroup>
          <Button onClick={() => navigate(`/admin/portfolio/categories`)}>
            Categories
          </Button>
          <Button onClick={() => navigate(`/admin/portfolio/countries`)}>
            Countries
          </Button>
          <Button primary onClick={() => navigate(`/admin/portfolio/new`)}>
            Add Item
          </Button>
        </ButtonGroup>
      }
    >
      <FormLayout>
        <Card padding="0">
          {loadingMarkup}

          <Filters
            queryValue={queryValue}
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          />

          <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Title
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Alias
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Country
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Category
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            ]}
            rows={items}
            sortable={[false, false, false, false]}
            defaultSortDirection="descending"
            initialSortColumnIndex={0}
            onSort={handleSort}
            verticalAlign="middle"
            stickyHeader
            // hasZebraStripingOnData
            footerContent={
              items?.length &&
              `Showing ${items.length} of ${totalPages} results`
            }
            increasedTableDensity
          />

          {emtyState}
        </Card>
        {Math.ceil(totalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              count={Math.ceil(totalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            />
          </div>
        )}
      </FormLayout>
      <Modal open={popupActive} loading={true}></Modal>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Brand"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this brand?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>

      {toastMarkup}
    </Page>
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
};

export default Portfolio;
